/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import * as Device from 'expo-device';

const getDeviceType = async () => {
let device;
device = await Device.getDeviceTypeAsync();
switch (device) {
case 0:
return "UNKNOWN";
case 1:
return "PHONE";
case 2:
return "TABLET";
case 3:
return "DESKTOP";
case 4:
return "TV";
default:
return device;
}
};

const isDesktop = async () => {
const device = await getDeviceType();
return device === "DESKTOP";
}


const DeviceDetector = {
getDeviceType,
isDesktop
}

export default DeviceDetector;